export type AppUser = {
  uid: string;
  email?: string | null;
  name?: string;
  role?: "superadmin" | "admin" | "user";
  approvalStatus?: "approved" | "pending";
  appAccessStatus?: "none" | "limited" | "full";
  billingStatus?:
    | "inactive"
    | "trialing"
    | "active"
    | "past_due"
    | "cancelled"
    | "incomplete";
  activeEntitlementId?: string | null;
  activeMembershipPlanId?: string | null;
};

type RawUserDoc = {
  name?: unknown;
  role?: unknown;
  approvalStatus?: unknown;
  appAccessStatus?: unknown;
  billingStatus?: unknown;
  activeEntitlementId?: unknown;
  activeMembershipPlanId?: unknown;
};

export function isSuperadminRole(role?: string | null): role is "superadmin" {
  return role === "superadmin";
}

export function isAdminRole(role?: string | null): role is "admin" | "superadmin" {
  return role === "admin" || role === "superadmin";
}

export function isMemberRole(role?: string | null): role is "user" | "admin" | "superadmin" {
  return role === "user" || role === "admin" || role === "superadmin";
}

export function buildAppUser(
  firebaseUser: { uid: string; email?: string | null },
  rawData?: RawUserDoc | null
): AppUser {
  const role =
    rawData?.role === "superadmin"
      ? "superadmin"
      : rawData?.role === "admin"
      ? "admin"
      : "user";

  return {
    uid: firebaseUser.uid,
    email: firebaseUser.email ?? null,
    name: typeof rawData?.name === "string" ? rawData.name : undefined,
    role,
    approvalStatus: rawData?.approvalStatus === "pending" ? "pending" : "approved",
    appAccessStatus:
      rawData?.appAccessStatus === "limited" || rawData?.appAccessStatus === "full"
        ? rawData.appAccessStatus
        : rawData?.approvalStatus === "pending"
        ? "none"
        : "full",
    billingStatus:
      rawData?.billingStatus === "trialing" ||
      rawData?.billingStatus === "active" ||
      rawData?.billingStatus === "past_due" ||
      rawData?.billingStatus === "cancelled" ||
      rawData?.billingStatus === "incomplete"
        ? rawData.billingStatus
        : "inactive",
    activeEntitlementId:
      typeof rawData?.activeEntitlementId === "string" ? rawData.activeEntitlementId : null,
    activeMembershipPlanId:
      typeof rawData?.activeMembershipPlanId === "string" ? rawData.activeMembershipPlanId : null,
  };
}

export function buildSafePendingAppUser(
  firebaseUser: { uid: string; email?: string | null }
): AppUser {
  return {
    uid: firebaseUser.uid,
    email: firebaseUser.email ?? null,
    role: "user",
    approvalStatus: "pending",
    appAccessStatus: "none",
    billingStatus: "inactive",
    activeEntitlementId: null,
    activeMembershipPlanId: null,
  };
}
